import { computed, ref, Ref } from 'vue'
import { Shift } from '../../shifts/models/shift'

export type ScheduleDuplicateDialogState = {
    visible: boolean
    shift: Shift | null
}

const state: Ref<ScheduleDuplicateDialogState> = ref({
    visible: false,
    shift: null,
})

export function useScheduleDuplicateDialog() {
    const show = (shift: Shift) => {
        state.value = {
            visible: true,
            shift,
        }
    }

    const hide = () => {
        state.value = {
            visible: false,
            shift: null,
        }
    }

    const isShown = computed(() => state.value.visible)
    const shift = computed(() => state.value.shift)

    return {
        show,
        hide,
        isShown,
        shift,
    }
}